<template>
  <div class="supplement content-wrapper">
    <div class="page-header">{{ $t('editSupplementType') }}</div>
    <div style="margin-bottom: 40px; margin-left: 5px;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'HotelSupplementTypeList' }">{{ $t('supplementTypeList') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('editSupplementType') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" label-width="150px" style="width: 500px">
      <el-form-item :label="$t('name')" :required="true">
        <el-input v-model="supplementType.name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onSaveButtonClick">{{ $t('saveChange') }}</el-button>
        <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/Supplement/ManageSupplement/Type/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import { getHotelIndexRoute } from '@/services/hotel-service'
import HotelSupplementTypeApi from '@/api/hotel/supplement-type-api'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { mapState } from 'vuex'
import { get } from 'lodash'

export default {
  name: 'HotelSupplementTypeEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { },
  i18n: { messages: i18nMessages },
  props: {
    supplementTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    supplementType: {
      type: Object,
      default: function () {
        return {
          id: '',
          name: ''
        }
      }
    }
  },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    const supplementTypeId = get(this.supplementType, 'id', '')

    if (supplementTypeId === '') {
      return this.$router.push({
        name: 'HotelSupplementItemList'
      })
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  methods: {
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelSupplementTypeList'
      })
    },
    onSaveButtonClick: async function () {
      try {
        this.startLoading()

        await HotelSupplementTypeApi.update(this.activeHotelId, this.supplementType.id, this.supplementType)
        this.$router.push({
          name: 'HotelSupplementTypeList'
        })

        const title = this.$t('updateSupplementTypeSuccessTitle')
        const message = this.$t('updateSupplementTypeSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
